/** @format */
import React, { ReactNode } from 'react';

export const ContentfulBold = (text: ReactNode) => <strong>{text}</strong>;
